var map = {
	"./csr_1_breast_cancer.jpg": 144,
	"./csr_2_makanan_berbuka.jpg": 145,
	"./csr_3_bersama_chiki.jpg": 146,
	"./csr_4_good_leader_good_teacher.jpg": 147,
	"./csr_5_komunitas_taufan.jpg": 148,
	"./csr_5_pengrajin_wanita_di_lombok.jpg": 149
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1390;